<template>
    <v-container>
        <template>
            <v-row justify="center">
                <v-dialog
                    v-model="previewDialog"
                    fullscreen
                    persistent
                >
                    <v-card>
                        <v-toolbar
                            dark
                            color="primary"
                        >
                            <v-btn
                                icon
                                dark
                                @click="previewDialog = false"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <v-toolbar-title>Preview</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-img
                            :src="previewImagePath"
                            contain
                            aspect-ratio="1.7"
                        >
                        </v-img>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>
        <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
        <v-data-table v-else
            :items="images"
            :items-per-page="5"
            :footer-props="{ 'items-per-page-options': [10,20,50,-1] }"
            :headers="mainHeaders"
            item-key="DocumentID"
            sort-by="DocumentID"
            :sort-desc="true">
            <template v-slot:header.Actions>
                <v-row justify="end">
                    <v-col cols="auto">
                        <AddFile v-if="canAddFiles"
                            ref="fileUpload" 
                            :allowedFileExtensions="allowedImageExtensions" 
                            @fileSelected="ImageSelected" 
                            @fileInvalid="ImageInvalid"
                            @save="saveImage"
                            :maxFileSizeMB="2" 
                        />
                    </v-col>
                </v-row>
            </template>
        
            <template v-slot:item.ImageID="{ item }">
                <template v-if="item.ImageID > 0">
                    <v-icon color="success">check</v-icon>
                </template>
                <template v-else>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon color="error"  dark v-bind="attrs" v-on="on">close</v-icon>
                        </template>
                        <div>File will be uploaded on saving the Medical Record</div>
                    </v-tooltip>
                </template>
            </template>
            <template v-slot:item.ImageName="{item}">
                <template v-if="item.ImageName">
                    {{ item.ImageName }}
                </template>
                <template v-else>
                    {{ item.FileName }}
                </template>
            </template>
            <template v-slot:item.Actions="{ item }">
                <v-btn
                    v-if="item.ImageS3Path"
                    :loading="loading"
                    color="info"
                    @click="preview(item.ImageS3Path)"
                >
                    Preview
                </v-btn>
                <v-btn
                    v-if="!closedMedicalRecord"
                    color="error"
                    :loading="loading"
                    @click="deleteMedicalRecordImage(item)"
                >
                    Delete
                </v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
import medicalRecordAPI from "../../services/medicalRecordAPI";
import fileService from "../../services/fileService";
import AddFile from "./AddFile.vue";

export default {

     components: {
        AddFile
        
    },
    props: {
        medicalRecordID: {
            type: String,
            default: ""
        },
        closedMedicalRecord: {
            type: Boolean,
            default: false
        },
        canAddFiles: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            previewing:false,
            previewImageDialog:false,
            previewImagePath:"",
            isPDF:true,
            images:[],
            loadingError: "",
            previewDialog:false,
            deleteItem:null,
            deleting:false,
            
            allowedImageExtensions: '.JPEG, .PNG, .JPG',

            mainHeaders: [
                {
                    text: "Uploaded",
                    value: "ImageID",
                    class: "min-width-column"
                },
                {
                    text: "Image Name",
                    value: "ImageName"
                },
                {
                    text: "",
                    value: "Actions",
                    sortable: false,
                    class: "min-width-column"
                },
            ]
        };
    },
    computed:{
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        }
    },
    methods: {

        ImageSelected(file) {
            this.fileError = '';
            this.pendingImage = file;
        },
        
        ImageInvalid(errorMessage) {
            this.fileError = errorMessage;
            this.pendingImage = null;
        },
        
        saveImage(image) {
            this.images.push(image);

            this.$emit('addFile', image);
        },

        async preview(s3Path) {

            this.previewImageDialog = true;
            this.loading = true;

            var filePath = await fileService.getDownloadURL(s3Path);
            this.loading = false;
            this.previewImagePath = filePath;
            this.previewDialog = true;        
        },
        async deleteMedicalRecordImage(image) {
            this.loading = true;
            this.loadingError = "";

            if(image.ImageID > 0) {
                try {
                    await medicalRecordAPI.deleteMedicalRecordImage(image.ImageID);
                } catch (e) {
                    this.loadingError = e.message
                }
                this.loadImages();
            }
            else {
                var delIndex = this.images.findIndex(img => img.FileName == image.FileName);
                this.images.splice(delIndex, 1);

                this.$emit('removeFile', image);
                this.loading = false;
                return;
            }
            
            
            this.loading = false;
        },
        async loadImages() {
            this.loading = true;
            this.loadingError = "";

            if(this.medicalRecordID){
                try {
                    this.images = await medicalRecordAPI.getMedicalRecordImages(this.medicalRecordID);
                    this.expanded = [ this.images[0] ]
                } catch (e) {
                    this.loadingError = e.message
                }
            }
            this.loading = false;
            
        },
},

async created() {
    await this.loadImages();
},

}
</script>

<style>
    .min-width-column {
        width: 1%;
    }
</style>

<style scoped>
    .expansion-panel {
        background-color: white;
    }
</style>